import { Link } from "react-router-dom";
import { ArrowLeft, Hammer } from "lucide-react";

export default function PlaceholderPage({ title, description }) {
  return (
    <section
      className="border-b border-border bg-white"
      data-testid={`placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="bb-container py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <div className="bb-overline text-bb-copper">Coming soon</div>
            <h1 className="bb-headline mt-4 text-4xl sm:text-5xl lg:text-6xl text-bb-navy">
              {title}
            </h1>
            <p className="mt-6 text-base lg:text-lg text-bb-slate max-w-2xl leading-relaxed">
              {description}
            </p>
            <div className="mt-10 inline-flex items-center gap-3 border border-border bg-bb-offwhite px-5 py-4">
              <Hammer size={18} className="text-bb-copper" />
              <span className="text-sm font-mono text-bb-slate">
                Currently in editorial &amp; engineering build. Subscribers
                will be notified at launch.
              </span>
            </div>
            <div className="mt-12">
              <Link
                to="/"
                className="bb-link inline-flex items-center gap-2 text-sm font-archivo uppercase tracking-widest text-bb-navy"
                data-testid="placeholder-back-home"
              >
                <ArrowLeft size={16} /> Back to the brief
              </Link>
            </div>
          </div>
          <aside className="lg:col-span-4">
            <div className="bb-card p-7">
              <div className="bb-overline text-bb-copper">In the meantime</div>
              <h3 className="font-archivo text-xl text-bb-navy mt-3 font-semibold">
                Get the Morning Brief.
              </h3>
              <p className="text-sm text-bb-slate mt-3 leading-relaxed">
                Weekdays, before the TSX opens. The day&rsquo;s Canadian mining
                sector in five minutes.
              </p>
              <a
                href="/#newsletter"
                className="bb-btn-primary inline-flex items-center justify-center px-5 py-3 text-sm mt-5"
                data-testid="placeholder-newsletter-cta"
              >
                Subscribe — Free
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
